import React, { createContext, useContext, useState } from 'react';

const ErrorContext = createContext();

export const useError = () => {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error('useError must be used within an ErrorProvider');
  }
  return context;
};

export const ErrorProvider = ({ children }) => {
  const [errorMessage, setErrorMessage] = useState('');
  const [errorSubMessage, setErrorSubMessage] = useState('');
  const [showError, setShowError] = useState(false);

  const showErrorMessage = (message, subMessage = '') => {
    setErrorMessage(message);
    setErrorSubMessage(subMessage);
    setShowError(true);
  };

  const hideErrorMessage = () => {
    setShowError(false);
    setErrorMessage('');
    setErrorSubMessage('');
  };

  const value = {
    errorMessage,
    errorSubMessage,
    showError,
    showErrorMessage,
    hideErrorMessage
  };

  return (
    <ErrorContext.Provider value={value}>
      {children}
    </ErrorContext.Provider>
  );
}; 